import { dashboardApiMiddleware } from "src/api";
import { CloudStorageInfo } from "./cloud-storage.interface";

export const getCloudStorageInfo = dashboardApiMiddleware<CloudStorageInfo>()({
  method: "get",
  endpoint: "/api/limit/v2/storage",
});
